// @generated by protoc-gen-es v2.10.0 with parameter "target=ts,import_extension=none"
// @generated from file proto/sem/middleware/inner_thoughts.proto (package sem.middleware.inner_thoughts, syntax proto3)
/* eslint-disable */

import type { Message } from "@bufbuild/protobuf";
import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/sem/middleware/inner_thoughts.proto.
 */
export const file_proto_sem_middleware_inner_thoughts: GenFile = /*@__PURE__*/
  fileDesc("Cilwcm90by9zZW0vbWlkZGxld2FyZS9pbm5lcl90aG91Z2h0cy5wcm90bxIdc2VtLm1pZGRsZXdhcmUuaW5uZXJfdGhvdWdodHMiJAoUSW5uZXJUaG91Z2h0c1BheWxvYWQSDAoEdGV4dBgBIAEoCSJqChRJbm5lclRob3VnaHRzU3RhcnRlZBIPCgdpdGVtX2lkGAEgASgJEkEKBGRhdGEYAiABKAsyMy5zZW0ubWlkZGxld2FyZS5pbm5lcl90aG91Z2h0cy5Jbm5lclRob3VnaHRzUGF5bG9hZCJpChNJbm5lclRob3VnaHRzVXBkYXRlEg8KB2l0ZW1faWQYASABKAkSQQoEZGF0YRgCIAEoCzIzLnNlbS5taWRkbGV3YXJlLmlubmVyX3Rob3VnaHRzLklubmVyVGhvdWdodHNQYXlsb2FkIowBChZJbm5lclRob3VnaHRzQ29tcGxldGVkEg8KB2l0ZW1faWQYASABKAkSQQoEZGF0YRgCIAEoCzIzLnNlbS5taWRkbGV3YXJlLmlubmVyX3Rob3VnaHRzLklubmVyVGhvdWdodHNQYXlsb2FkEg8KB3N1Y2Nlc3MYAyABKAgSDQoFZXJyb3IYBCABKAlCVlpUZ2l0aHViLmNvbS90ZWFtLW1lbnRvL21lbnRvLXBsYXlncm91bmQvZ28vcGtnL3NlbS9wYi9wcm90by9zZW0vbWlkZGxld2FyZTttaWRkbGV3YXJlYgZwcm90bzM");

/**
 * @generated from message sem.middleware.inner_thoughts.InnerThoughtsPayload
 */
export type InnerThoughtsPayload = Message<"sem.middleware.inner_thoughts.InnerThoughtsPayload"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message sem.middleware.inner_thoughts.InnerThoughtsPayload.
 * Use `create(InnerThoughtsPayloadSchema)` to create a new message.
 */
export const InnerThoughtsPayloadSchema: GenMessage<InnerThoughtsPayload> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_inner_thoughts, 0);

/**
 * @generated from message sem.middleware.inner_thoughts.InnerThoughtsStarted
 */
export type InnerThoughtsStarted = Message<"sem.middleware.inner_thoughts.InnerThoughtsStarted"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.inner_thoughts.InnerThoughtsPayload data = 2;
   */
  data?: InnerThoughtsPayload;
};

/**
 * Describes the message sem.middleware.inner_thoughts.InnerThoughtsStarted.
 * Use `create(InnerThoughtsStartedSchema)` to create a new message.
 */
export const InnerThoughtsStartedSchema: GenMessage<InnerThoughtsStarted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_inner_thoughts, 1);

/**
 * @generated from message sem.middleware.inner_thoughts.InnerThoughtsUpdate
 */
export type InnerThoughtsUpdate = Message<"sem.middleware.inner_thoughts.InnerThoughtsUpdate"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.inner_thoughts.InnerThoughtsPayload data = 2;
   */
  data?: InnerThoughtsPayload;
};

/**
 * Describes the message sem.middleware.inner_thoughts.InnerThoughtsUpdate.
 * Use `create(InnerThoughtsUpdateSchema)` to create a new message.
 */
export const InnerThoughtsUpdateSchema: GenMessage<InnerThoughtsUpdate> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_inner_thoughts, 2);

/**
 * @generated from message sem.middleware.inner_thoughts.InnerThoughtsCompleted
 */
export type InnerThoughtsCompleted = Message<"sem.middleware.inner_thoughts.InnerThoughtsCompleted"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.inner_thoughts.InnerThoughtsPayload data = 2;
   */
  data?: InnerThoughtsPayload;

  /**
   * @generated from field: bool success = 3;
   */
  success: boolean;

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message sem.middleware.inner_thoughts.InnerThoughtsCompleted.
 * Use `create(InnerThoughtsCompletedSchema)` to create a new message.
 */
export const InnerThoughtsCompletedSchema: GenMessage<InnerThoughtsCompleted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_inner_thoughts, 3);

